import { render } from "./Add.vue?vue&type=template&id=5bcbaffb"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=5bcbaffb&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/teacher/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bcbaffb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bcbaffb', __exports__)) {
    console.log('reload')
    api.reload('5bcbaffb', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=5bcbaffb", () => {
    console.log('re-render')
    api.rerender('5bcbaffb', render)
  })

}


export default __exports__